import { createApiClient } from '@platform/api-client';

export { ApiError, type RequestOptions } from '@platform/api-client';

/**
 * Web instance of the shared platform client (@platform/api-client). The
 * refresh token travels in the httpOnly cookie, so this instance sends
 * credentials and never touches the token itself. Module-level named exports
 * are preserved so page/hook code is untouched by the extraction.
 */
const client = createApiClient({
  baseUrl: '/api/v1',
  credentials: 'include',
});

export const {
  apiFetch,
  apiFetchBlob,
  setAccessToken,
  getAccessToken,
  setActiveOrganizationId,
  setAdminActAsOrganizationId,
  setOnUnauthorizedHandler,
} = client;
